/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  assign_calendar_event_link_to_candidate_action,
  get_applicant_profile_info_action,
  get_calendar_event_availability_action,
  get_calendar_event_lists_action,
  reset_applicant_dashboard_action,
} from "../../../redux/_actions";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

function useHiringProcessDashboard(props) {
  const [userProfileInfo, setUserProfileInfo] = useState({});
  const [applicantId, setApplicantId] = useState();
  const [userPrimarySkills, setUserPrimarySkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [applicantProfileLoading, setApplicantProfileLoading] = useState(false);
  const [calendarEventLists, setCalendarEventLists] = useState([]);

  const [scheduleInterviewModal, setscheduleInterviewModal] = useState(false);

  const [applicantHmsVideos, setApplicantHmsVideos] = useState([]);

  const [nextPage, setNextPage] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [lastElement, setLastElement] = useState(null);
  const [userData, setUserData] = useState({});


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { applicantProfileData } = useSelector(
    (state) => state.get_applicant_profile_info_reducer
  );

  const { calendarEventListsData } = useSelector(
    (state) => state.get_calendar_event_lists_data_reducer
  );

  const { applicantHmsVideosData } = useSelector(
    (state) => state.get_applicant_hms_videos_reducer
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("jigsawUser"));
    if (user) {
      setUserData(user && user.user);
    }
  }, []);

  useEffect(() => {
    let applicant_id = params?.id;
    if (applicant_id !== null) {
      setApplicantId(applicant_id);
      getUserData(applicant_id);
    }
  }, []);

  useEffect(() => {
    if (applicantProfileData) {
      if (applicantProfileData?.data?.id !== parseInt(params?.id)) {
        reset_applicant_dashboard_action();
        return;
      }
      setUserProfileInfo(applicantProfileData?.data);
    }
  }, [applicantProfileData]);

  useEffect(() => {
    if (applicantProfileData?.data) {
      getUserPrimarySkills(applicantProfileData?.data);
    }
  }, [applicantProfileData]);

  useEffect(() => {
    if (calendarEventListsData?.data) {
      let data = calendarEventListsData.data?.results;
      let results = calendarEventLists;
      data.forEach((newItem) => {
        if (!results.find((item) => item.id === newItem.id)) {
          results.push(newItem);
        }
      });
      setCalendarEventLists(results);
      setNextPage(calendarEventListsData?.data.next);
    }
  }, [calendarEventListsData]);

  useEffect(() => {
    if (nextPage !== null) {
      callEventListsApi();
    }
  }, [pageNum]);

  useEffect(() => {
    const currentElement = lastElement;
    const currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [lastElement]);

  useEffect(() => {
    if (applicantHmsVideosData?.data) {
      if (applicantProfileData?.data?.id === parseInt(params?.id)) {
        setApplicantHmsVideos(applicantHmsVideosData?.data);
      } else setApplicantHmsVideos([]);
    }
  }, [applicantHmsVideosData, applicantProfileData]);

  const observer = useRef(
    new IntersectionObserver((entries) => {
      const first = entries[0];
      if (first.isIntersecting) {
        setPageNum((no) => no + 1);
      }
    })
  );

  const getUserData = async (applicant_id) => {
    setLoading(true);
    setApplicantProfileLoading(true);
    await dispatch(get_applicant_profile_info_action(applicant_id));
    setLoading(false);
    setApplicantProfileLoading(false);
  };
  const callEventListsApi = async () => {
    await dispatch(get_calendar_event_lists_action());
  };

  const onNavigateBack = () => {
    navigate(-1);
  };
  const getUserPrimarySkills = (data) => {
    let skills =
      data?.candidate_profile_details && data.candidate_profile_details?.skills;

    let results = skills && skills.filter((item) => item?.is_primary === true);

    if (results.length > 0) setUserPrimarySkills(results);
    else setUserPrimarySkills(skills);
  };

  const onScheduleInterviewClick = async (id) => {
    await callEventListsApi();
    setscheduleInterviewModal((e) => !e);
  };

  const onAssignInterviewEventClick = async (event) => {
    if (event?.hash_id) {
      let res = await dispatch(
        get_calendar_event_availability_action(event?.hash_id)
      );

      if (res?.data) {
        let id = res?.data && res.data?.id;

        if (id) {
          let data = {
            candidate: applicantProfileData?.data.candidate,
            candidate_job_application: applicantProfileData?.data.id,
            event_availability: id,
          };
          await dispatch(assign_calendar_event_link_to_candidate_action(data));
          getUserData(applicantId);
          showSuccessMessage("Schedule event link successfully assigned.");
        }
      }
      setscheduleInterviewModal(false);
    } else {
      showWarningMessage("Assign your availability to this event.");
    }
  };

  const onEventEditClick = (id) => {
    navigate(`/create-event/${id}`, { state: id });
  };

  const onCreateEventClick = () => {
    navigate("/create-event");
  };

  const getJoineesNames = (hmsRoomDetail) => {
    let arr = [];
    if (hmsRoomDetail?.name) {
      if (arr[0]) arr[1] = hmsRoomDetail?.name;
      else arr[0] = hmsRoomDetail?.name;
    }
    if (hmsRoomDetail?.mentor) {
      if (arr[0]) arr[1] = hmsRoomDetail.mentor?.full_name;
      else arr[0] = hmsRoomDetail.mentor?.full_name;
    }
    if (hmsRoomDetail?.candidate) {
      if (arr[0]) arr[1] = hmsRoomDetail.candidate?.full_name;
      else arr[0] = hmsRoomDetail.candidate?.full_name;
    }
    if (hmsRoomDetail?.hiring_manager) {
      if (arr[0]) arr[1] = hmsRoomDetail.hiring_manager?.full_name;
      else arr[0] = hmsRoomDetail.hiring_manager?.full_name;
    }
    return arr;
  };

  return {
    applicantProfileLoading,
    scheduleInterviewModal,
    calendarEventLists,
    userProfileInfo,
    userPrimarySkills,
    applicantHmsVideos,
    applicantId,
    loading,
    userData,
    onNavigateBack,
    onScheduleInterviewClick,
    setLastElement,
    onAssignInterviewEventClick,
    onEventEditClick,
    onCreateEventClick,
    getJoineesNames,
  };
}
export default useHiringProcessDashboard;
